// extracted by mini-css-extract-plugin
export default {"wrapper":"uB-z","button":"vB-z","alternate":"wB-z","disabled":"xB-z","paymentWarning":"yB-z","fadeIn":"zB-z"};